<script>

    import StatisticsService from '../$services/statistics.service'
    import StatsCard from '../$components/stats.card.svelte'

    export let dateStart = null
    export let dateEnd = null

    let value = 0
    let change = 0
    let sparkline = []

    $: load(dateStart, dateEnd)

    async function load(start, end) {
        if (!start || !end) return

        const res = await StatisticsService.getPickupsScheduled({
            dateStart: start.toISOString(),
            dateEnd: end.toISOString(),
        })

        const data = res?.data
        if (!data) return

        value = data.value ?? 0
        change = data.change ?? 0
        sparkline = data.sparkline ?? []
    }

</script>

<StatsCard
    icon=""
    title="Recolecciones programadas"
    { value }
    { change }
    { sparkline }
    compare=""
/>
